<header>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="col-12 col-sm-4 col-md-4 logo-wrapper">
          <a href="{{authoringContentData?.common_authoring?.tmobileLogoUrl}}" target="_blank" rel="noopener">
            <img src="/assets/tfb-acctmgmt/images/desktoplogo.png" class="payment-logo d-none d-sm-none d-md-block" alt="">
            <img src="/assets/tfb-acctmgmt/images/mobilelogo.png" class="payment-logo d-block d-md-none" alt="">
          </a>
        </div>
        <!-- mobile menu icon -->
        <div class="menu-icon" (click)="shouldShow = !shouldShow">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="col-12 col-sm-12 col-md-8 right-text" *ngIf='isAuthenticated' >
          <ul class="main-menu" [ngClass]="{'showitem': shouldShow}">
            <li>
              <a [routerLink]="'/apps/tfb_acctmgmt/account-management/home'" (click)="onClickMngAcc()" class="white-text arrow-btm mnge-menu">
                {{authoringContentData?.common_authoring?.manageAccounts}} 
                <span></span>
              </a>
            </li>
            <li *ngIf="isAuthenticated">
              <div ngbDropdown class="d-inline-block white-text dropdown-main">
                <a id="dropdownBasic1" ngbDropdownToggle>{{userName}}</a>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <a class="dropdown-item" href="javascript:void(0)" (click)="logOutFromOkta()">{{authoringContentData?.common_authoring?.signOutTxt}}</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- Logo wrapper end here -->
      </div>
    </div>
  </div>
</header>